import { TimeLineMonth } from './time-line-month';

export class TimeLineDay {

    date: Date;
    
    week: number;
    dayOfWeek: number;
    month: TimeLineMonth;
    hasActivities: boolean;
}